import { mount } from "@vue/test-utils";
import OfferGroup from "@/components/core/OfferGroup";

jest.mock("@/components/core/OfferGroup", () => ({
  ...jest.requireActual("@/components/core/OfferGroup"),
  methods: {
    items: jest.fn()
  }
}));

describe("OfferGroup test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(OfferGroup);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component OfferGroup", () => {
    expect(wrapper).toBeDefined();
  });
});
